export default "__VITE_ASSET__DvL0w4dS__$_?nuxt_component=async&nuxt_component_name=SvgoGoogleicon&nuxt_component_export=default__"